(() => {
  const ROOT_SELECTOR = '#app-quotes';

  const onPopupReady = (popup) => {
    if (popup.dataset.gdEnhanced === '1') return;
    popup.dataset.gdEnhanced = '1';

    const closeLink = popup.querySelector('.close-btn > a');
    if (closeLink) closeLink.removeAttribute('style');

    const noteHeader = popup.querySelector('.omg-form-collapse-header');
    const noteWrap = noteHeader?.closest('.omg-form-100');
    if (noteHeader && noteWrap) {
      noteWrap.classList.remove('is-collapsed');
      noteHeader.setAttribute('role', 'button');
      noteHeader.setAttribute('tabindex', '0');
      noteHeader.setAttribute('aria-expanded', 'true');

      const toggle = () => {
        const collapsed = noteWrap.classList.toggle('is-collapsed');
        noteHeader.setAttribute('aria-expanded', String(!collapsed));
      };

      noteHeader.addEventListener('click', (e) => {
        if (e.target.closest('input, textarea, select, a')) return;
        toggle();
      });
      noteHeader.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    }
  };

  const fireInputChange = (input) => {
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const enhanceQtyInput = (wrapper) => {
    if (wrapper.dataset.gdQtyEnhanced === '1') return;
    const input = wrapper.querySelector('input.item_qty');
    if (!input) return;
    wrapper.dataset.gdQtyEnhanced = '1';

    const min = parseInt(input.min || '1', 10) || 1;

    const minus = document.createElement('button');
    minus.type = 'button';
    minus.className = 'omgrfq-qty-btn omgrfq-qty-btn--minus';
    minus.setAttribute('aria-label', 'Decrease quantity');
    minus.textContent = '−';

    const plus = document.createElement('button');
    plus.type = 'button';
    plus.className = 'omgrfq-qty-btn omgrfq-qty-btn--plus';
    plus.setAttribute('aria-label', 'Increase quantity');
    plus.textContent = '+';

    const sync = () => {
      const val = parseInt(input.value || String(min), 10) || min;
      minus.disabled = val <= min;
    };

    minus.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      input.removeAttribute('readonly');
      const val = parseInt(input.value || String(min), 10) || min;
      input.value = String(Math.max(min, val - 1));
      fireInputChange(input);
      sync();
    });

    plus.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      input.removeAttribute('readonly');
      const val = parseInt(input.value || String(min), 10) || min;
      input.value = String(val + 1);
      fireInputChange(input);
      sync();
    });

    input.addEventListener('input', sync);
    input.addEventListener('change', sync);

    wrapper.insertBefore(minus, input);
    wrapper.appendChild(plus);
    sync();
  };

  const enforceSiretPattern = (input) => {
    if (input.dataset.gdSiretPatched === '1') return;
    input.dataset.gdSiretPatched = '1';
    input.setAttribute('pattern', '^\\d{14}$');
    input.setAttribute('inputmode', 'numeric');
    input.setAttribute('maxlength', '14');
  };

  const scan = (root) => {
    root.querySelectorAll('.omgrfq-popup-wrapper').forEach(onPopupReady);
    root.querySelectorAll('.omgrfq-input-price').forEach(enhanceQtyInput);
    root.querySelectorAll('#omgrfq-form_0').forEach(enforceSiretPattern);
  };

  const init = () => {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;

    scan(root);

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        m.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches?.('.omgrfq-popup-wrapper')) onPopupReady(node);
          if (node.querySelectorAll) scan(node);
        });
      }
    });
    observer.observe(root, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      const wait = setInterval(() => {
        if (document.querySelector(ROOT_SELECTOR)) {
          clearInterval(wait);
          init();
        }
      }, 250);
    });
  } else {
    const wait = setInterval(() => {
      if (document.querySelector(ROOT_SELECTOR)) {
        clearInterval(wait);
        init();
      }
    }, 250);
  }
})();
